import { HomeType } from "@graphql/api";

export const mapHomeType = (homeType?: HomeType | null) => {
  switch (homeType) {
    case HomeType.AccessoryDwellingUnit:
      return "Accessory dwelling unit";
    case HomeType.CrossMod:
      return "CrossMod";
    case HomeType.DoubleWide:
      return "Double wide";
    case HomeType.Duplex:
      return "Duplex";
    case HomeType.Modular:
      return "Modular";
    case HomeType.ParkModel:
      return "Park model";
    case HomeType.SingleWide:
      return "Single wide";
    case HomeType.StationaryTravelTrailer:
      return "Stationary travel trailer";
    case HomeType.TinyHome:
      return "Tiny home";
    case HomeType.TripleWide:
      return "Triple wide";
    case HomeType.Unknown:
      return "Unknown";
    default:
      return "N/A";
  }
};
